// extracted by mini-css-extract-plugin
module.exports = {"root":"DividerBlock-module--root--1qvRm utilities-module--full--20TW4"};